import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import StorageManager from "utils/storageManager";
import { getPathPrefix } from "utils/coreUtils";

const CheckSelectedDataStream = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const streamObj = useSelector((state) => state?.datastream?.selected);
  const datastreamList = useSelector((state) => state?.datastream?.list);

  const checkSelectedDataStreamIsExist = async () => {
    const { dataStreamConfigId } = streamObj;
    try {
      const isExistDataStream = datastreamList?.some((element) => {
        return "" + element.dataStreamConfigId === "" + dataStreamConfigId;
      });
      if (!isExistDataStream) {
        StorageManager.removeSelectedDataStream();
        navigate(getPathPrefix("dashboard"), {
          replace: true,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (streamObj) {
      checkSelectedDataStreamIsExist();
    }
  }, [location.pathname]);
  return <Outlet />;
};

export default CheckSelectedDataStream;
